import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { REVIEW_RESULT_VIEW } from 'reducers/reviewResultSlice';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { E_SIGN_PDF_STATUS } from './RabbitResultDocusignAcknowledge';

export const getReviewRequestAcknowledgeSignApi = ({ reviewId, employeeId, providerId, responseId, employeeEmail }) => {
  const url = endpoints.analytics.review.generateReviewSummaryPDF;

  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       entity: {},
  //     });
  //   }, 3000); // 10 seconds
  // });

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      reviewId,
      empId: employeeId,
      providerId,
      responseId,
      receiverEmail: '',
      reportView: REVIEW_RESULT_VIEW.QUESTION,
      isDeerUI: true,
      //   reportViewerPersona,
      employeeEmail,
      isAcknowledgeFlow: true,
    },
  });
};

export const useReviewRequestAcknowledgeSign = ({ reviewId, employeeId, providerId, responseId, employeeEmail }) =>
  useQuery(
    [REACT_QUERY_KEYS.reviewAcknowledge.acknowledgeRequest, reviewId],
    () =>
      getReviewRequestAcknowledgeSignApi({
        reviewId,
        employeeId,
        providerId,
        responseId,
        employeeEmail,
      }).then((res) => res.entity),
    { enabled: !!reviewId, retry: false }
  );

export const getAcknowledgePollApi = ({ feedbackFormId }) => {
  const url = endpoints.performanceReview.reviewAcknowledge.acknowledgePoll;

  // return Promise.resolve({
  //   entity: {
  //     // status: E_SIGN_PDF_STATUS.IN_PROGESS,

  //     status: E_SIGN_PDF_STATUS.COMPLETED,
  //     signingLink:
  //       'https://demo.docusign.net/Signing/MTRedeem/v1/b73e9533-ab07-44bf-8dac-5971252a5f98?slt=eyJ0eXAiOiJNVCIsImFsZyI6IlJTMjU2Iiwia2lkIjoiNjgxODVmZjEtNGU1MS00Y2U5LWFmMWMtNjg5ODEyMjAzMzE3In0.AQYAAAABAAMABwAA-wmqojvdSAgAAJsbMcQ73UgYAAEAAAAAAAAAIQDsAgAAeyJUb2tlbklkIjoiYzMyZjkwZDAtOGYyMy00MzZhLWFlNTctN2Q1MDgxZGRkZjAxIiwiRXhwaXJhdGlvbiI6IjIwMjUtMDEtMjNUMTE6NDQ6NTgrMDA6MDAiLCJJc3N1ZWRBdCI6IjIwMjUtMDEtMjNUMTE6Mzk6NTguNDkxMjIzNSswMDowMCIsIlJlc291cmNlSWQiOiIyODAyNjI2Yi0yZmRhLTRjZGItODYzNC1iYTYzYjBmMzhkZGMiLCJSZXNvdXJjZXMiOiJ7XCJFbnZlbG9wZUlkXCI6XCIyODAyNjI2Yi0yZmRhLTRjZGItODYzNC1iYTYzYjBmMzhkZGNcIixcIkFjdG9yVXNlcklkXCI6XCI4OGYwODAzNi04MTNlLTQ2ZmMtOGRjMC1iNTE2Y2RjMDI5YjBcIixcIlJlY2lwaWVudElkXCI6XCI3OGM4Y2Q1Ni00MDdhLTQxYjItOGYyNi1hYzgxNTRmNTFhZDRcIixcIkZha2VRdWVyeVN0cmluZ1wiOlwidD03MTk3ZmYwMy1kZGMyLTQ4MTAtYTM3NC03MzZmMTVlYzg5NDFcIixcIkludGVncmF0b3JLZXlcIjpcIjk0NzE3NTMwLTE1YWEtNDlhZS1iNzBjLWYyZDcxNGM3OTAxMlwiLFwiQ3JlYXRlZEF0XCI6XCIyMDI1LTAxLTIzVDExOjM5OjU4LjQ3NDkwMjlaXCJ9IiwiVG9rZW5UeXBlIjoxLCJBdWRpZW5jZSI6IjI1ZTA5Mzk4LTAzNDQtNDkwYy04ZTUzLTNhYjJjYTU2MjdiZiIsIlJlZGlyZWN0VXJpIjoiaHR0cHM6Ly9kZW1vLmRvY3VzaWduLm5ldC9TaWduaW5nL1N0YXJ0SW5TZXNzaW9uLmFzcHgiLCJIYXNoQWxnb3JpdGhtIjowLCJIYXNoUm91bmRzIjowLCJUb2tlblN0YXR1cyI6MCwiSXNTaW5nbGVVc2UiOmZhbHNlfT8AgMJBXKM73Ug.kDUBWPGNuFLKhr7PxKfDxxOAD4PMgNUrDh7nw1ZCYxZweLV6wK3fJsq9Jkbr-eAlUte3LyYfPZQBt4OKaqQEwgMPxjhnkowDdTlxF2AWdfsa5oF62DMdet2w_rzfyUsF1w-c8rzXnAkOgR-KXwXqFwgS3_ZqwuBvNmVVy1a0crbL9oPy0WenegZa0t4dRlhDF6smDd7f7Ucd3quRxXCs8131PFjn9cpkfs4T3WMI6Jrypm16_NuhSMTuAZXTq4ZlGGPSFeU9I3Qb096xIXaTWEKeusHAPzk0Q607hiaEsbzD7IHhe2ufpcHYI5wWX-9SjXCfSDm7aq5T5jc2zZ8B2Q',
  //   },
  // });
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      feedbackFormId,
    },
  });
};

export const useReviewAcknowledgeSignPoll = ({ feedbackFormId, isEnabled }) =>
  useQuery(
    [REACT_QUERY_KEYS.reviewAcknowledge.acknowledgeRequestPolling, feedbackFormId],
    () =>
      getAcknowledgePollApi({
        feedbackFormId,
      }).then((res) => res.entity),

    {
      enabled: !!isEnabled,
      retry: false,
      refetchInterval: (data) => {
        if (data?.status === E_SIGN_PDF_STATUS.STARTED) {
          // try again after 5 sec
          return 5000;
        }
        return false;
      },
    }
  );
